import $ from 'jquery';

// Helper function to wrap an HTML structure around an element.
export default function tables(Drupal, once) {
  function wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }

// Wrap textarea tables with .table-responsive.
document.addEventListener("DOMContentLoaded", function () {
  // Check if the element exists before trying to wrap it.
  let textareaTable = document.querySelector('.text-area table');
  if (textareaTable) {
    let newTable = document.createElement('div');
    newTable.className = 'table-responsive';
    wrap(textareaTable, newTable);
  }
 });
}
